import React from 'react';
import { Tabs } from '../components/ui/Tabs';
export function LegalPage() {
  const faqContent = <div className="space-y-8" data-id="element-660">
      <div data-id="element-661">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-662">
          Koji je rok isporuke za porudžbine?
        </h3>
        <p className="text-gray-300 leading-relaxed" data-id="element-663">
          Standardni rok isporuke je približno 2 meseca od potvrde porudžbine.
          Ovaj vremenski okvir nam omogućava da obezbedimo kontrolu kvaliteta i
          pravilnu logistiku. Pružićemo vam specifičnu procenu isporuke kada
          poručite.
        </p>
      </div>

      <div data-id="element-664">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-665">
          Da li cena uključuje PDV?
        </h3>
        <p className="text-gray-300 leading-relaxed" data-id="element-666">
          Navedene cene ne uključuju PDV. PDV se može primeniti u zavisnosti od
          vaše lokacije i poslovnog statusa. Pružićemo vam kompletnu ponudu
          uključujući sve primenjive poreze kada zatražite ponudu.
        </p>
      </div>

      <div data-id="element-667">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-668">
          Koja garancija je uključena?
        </h3>
        <p className="text-gray-300 leading-relaxed" data-id="element-669">
          Svi D-TECH proizvodi uključuju sveobuhvatnu garanciju. Specifični
          uslovi variraju po modelu i detaljno su navedeni u vašem ugovoru o
          kupovini. Stojimo iza naše opreme sa tehničkom podrškom i dostupnošću
          rezervnih delova.
        </p>
      </div>

      <div data-id="element-670">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-671">
          Da li nudite obuku i podršku?
        </h3>
        <p className="text-gray-300 leading-relaxed" data-id="element-672">
          Da. Pružamo tehničku dokumentaciju, materijale za operativnu obuku i
          stalnu podršku tokom radnog vremena (10:00-17:00 CET,
          ponedeljak-petak). Kontaktirajte nas na info@dtech.rs za upite o
          podršci.
        </p>
      </div>

      <div data-id="element-673">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-674">
          Mogu li zatražiti demonstraciju pre kupovine?
        </h3>
        <p className="text-gray-300 leading-relaxed" data-id="element-675">
          Apsolutno. Nudimo demonstracije na licu mesta na vašoj lokaciji.
          Zahtevi za demonstraciju moraju biti podneseni najmanje 5 dana unapred
          radi koordinacije rasporeda i logistike. Koristite našu formu za
          zahtev za demonstraciju da počnete.
        </p>
      </div>

      <div data-id="element-676">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-677">
          Koje načine plaćanja prihvatate?
        </h3>
        <p className="text-gray-300 leading-relaxed" data-id="element-678">
          Prihvatamo bankovne transfere i standardne B2B uslove plaćanja.
          Specifični aranžmani plaćanja se razmatraju tokom procesa ponude.
          Radimo sa preduzećima da pronađemo odgovarajuće strukture plaćanja.
        </p>
      </div>

      <div data-id="element-679">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-680">
          Da li šaljete međunarodno?
        </h3>
        <p className="text-gray-300 leading-relaxed" data-id="element-681">
          Primarno služimo evropsko tržište. Međunarodna dostava može biti
          dostupna u zavisnosti od lokacije. Kontaktirajte nas da razgovaramo o
          vašim specifičnim zahtevima i radićemo da ispunimo vaše potrebe.
        </p>
      </div>

      <div data-id="element-682">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-683">
          Koje održavanje je potrebno?
        </h3>
        <p className="text-gray-300 leading-relaxed" data-id="element-684">
          D-TECH oprema je dizajnirana za lako održavanje. Redovne inspekcije,
          nega baterije i osnovno čišćenje su primarni zahtevi. Detaljni
          rasporedi održavanja i procedure su uključeni sa vašom opremom.
        </p>
      </div>
    </div>;
  const termsContent = <div className="space-y-6 text-gray-300 leading-relaxed" data-id="element-685">
      <div data-id="element-686">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-687">
          1. Prihvatanje uslova
        </h3>
        <p data-id="element-688">
          Pristupanjem ili korišćenjem usluga D-TECH Solutions, slažete se da
          budete obavezani ovim Uslovima korišćenja. Ako se ne slažete sa bilo
          kojim delom ovih uslova, ne možete pristupiti našim uslugama.
        </p>
      </div>

      <div data-id="element-689">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-690">2. Poslovni odnos</h3>
        <p data-id="element-691">
          D-TECH Solutions pruža industrijsku opremu poslovnim klijentima. Sve
          transakcije su B2B (poslovanje sa poslom) osim ako nije drugačije
          navedeno. Klijenti moraju pružiti važeće informacije o poslovnoj
          registraciji.
        </p>
      </div>

      <div data-id="element-692">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-693">
          3. Porudžbine i ponude
        </h3>
        <p data-id="element-694">
          Ponude važe 30 dana od izdavanja. Porudžbine se potvrđuju po prijemu
          potpisanog ugovora o kupovini i depozita (ako je primenjivo). Rokovi
          isporuke su procene i mogu varirati na osnovu proizvodnje i logistike.
        </p>
      </div>

      <div data-id="element-695">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-696">
          4. Cene i plaćanje
        </h3>
        <p data-id="element-697">
          Sve cene su u EUR i ne uključuju PDV osim ako nije drugačije navedeno.
          Uslovi plaćanja su navedeni u pojedinačnim ugovorima o kupovini.
          Kašnjenja u plaćanju mogu dovesti do kamata kako je dozvoljeno
          zakonom.
        </p>
      </div>

      <div data-id="element-698">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-699">
          5. Isporuka i rizik
        </h3>
        <p data-id="element-700">
          Rizik gubitka prelazi na kupca po isporuci. Datumi isporuke su
          procene. D-TECH Solutions nije odgovoran za kašnjenja van naše razumne
          kontrole.
        </p>
      </div>

      <div data-id="element-701">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-702">6. Garancija</h3>
        <p data-id="element-703">
          Proizvodi su pokriveni garancijom proizvođača kako je navedeno u
          dokumentaciji o kupovini. Garancija ne pokriva zloupotrebe,
          neovlašćene modifikacije ili normalno habanje.
        </p>
      </div>

      <div data-id="element-704">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-705">
          7. Ograničenje odgovornosti
        </h3>
        <p data-id="element-706">
          Odgovornost D-TECH Solutions je ograničena na kupovnu cenu opreme.
          Nismo odgovorni za indirektne, posledične ili slučajne štete.
        </p>
      </div>

      <div data-id="element-707">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-708">
          8. Primenjivo pravo
        </h3>
        <p data-id="element-709">
          Ovi uslovi su regulisani zakonima jurisdikcije gde je D-TECH Solutions
          registrovan. Sporovi će biti rešeni arbitražom ili sudovima u toj
          jurisdikciji.
        </p>
      </div>

      <div data-id="element-710">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-711">9. Promene uslova</h3>
        <p data-id="element-712">
          Zadržavamo pravo da izmenimo ove uslove u bilo kom trenutku. Promene
          će biti objavljene na ovoj stranici sa ažuriranim datumom revizije.
          Nastavak korišćenja predstavlja prihvatanje izmenjenih uslova.
        </p>
      </div>

      <p className="text-sm text-gray-400 mt-8" data-id="element-713">
        Poslednje ažuriranje:{' '}
        {new Date().toLocaleDateString('sr-RS', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>
    </div>;
  const privacyContent = <div className="space-y-6 text-gray-300 leading-relaxed" data-id="element-714">
      <div data-id="element-715">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-716">
          1. Informacije koje prikupljamo
        </h3>
        <p data-id="element-717">
          Prikupljamo informacije koje nam direktno pružate, uključujući ime,
          email, broj telefona, detalje o kompaniji i sve druge informacije koje
          izaberete da pružite kada tražite ponude, demonstracije ili nas
          kontaktirate.
        </p>
      </div>

      <div data-id="element-718">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-719">
          2. Kako koristimo vaše informacije
        </h3>
        <p data-id="element-720">
          Koristimo prikupljene informacije da: obradimo vaše zahteve i
          porudžbine, komuniciramo sa vama o proizvodima i uslugama, pružimo
          korisničku podršku, poboljšamo naše usluge i ispunimo zakonske
          obaveze.
        </p>
      </div>

      <div data-id="element-721">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-722">
          3. Deljenje informacija
        </h3>
        <p data-id="element-723">
          Ne prodajemo vaše lične informacije. Možemo deliti informacije sa
          pružaocima usluga koji pomažu u našim operacijama, uz vašu saglasnost
          ili kako zakon zahteva.
        </p>
      </div>

      <div data-id="element-724">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-725">
          4. Bezbednost podataka
        </h3>
        <p data-id="element-726">
          Primenjujemo odgovarajuće tehničke i organizacione mere za zaštitu
          vaših ličnih informacija. Međutim, nijedan metod prenosa preko
          interneta nije 100% siguran.
        </p>
      </div>

      <div data-id="element-727">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-728">
          5. Vaša prava (GDPR)
        </h3>
        <p data-id="element-729">
          Prema GDPR-u, imate prava da: pristupite svojim ličnim podacima,
          ispravite netačne podatke, obrišete svoje podatke, ograničite obradu,
          prenosivost podataka i prigovorite obradi. Kontaktirajte nas da
          ostvarite ova prava.
        </p>
      </div>

      <div data-id="element-730">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-731">
          6. Čuvanje podataka
        </h3>
        <p data-id="element-732">
          Čuvamo lične informacije onoliko dugo koliko je potrebno da ispunimo
          svrhe navedene u ovoj politici, osim ako je duži period čuvanja
          potreban po zakonu.
        </p>
      </div>

      <div data-id="element-733">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-734">
          7. Kolačići i praćenje
        </h3>
        <p data-id="element-735">
          Naša veb stranica može koristiti kolačiće i slične tehnologije
          praćenja za poboljšanje korisničkog iskustva. Možete kontrolisati
          postavke kolačića kroz podešavanja vašeg pretraživača.
        </p>
      </div>

      <div data-id="element-736">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-737">
          8. Linkovi trećih strana
        </h3>
        <p data-id="element-738">
          Naša veb stranica može sadržati linkove ka sajtovima trećih strana.
          Nismo odgovorni za prakse privatnosti ovih sajtova. Preporučujemo vam
          da pregledate njihove politike privatnosti.
        </p>
      </div>

      <div data-id="element-739">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-740">
          9. Privatnost dece
        </h3>
        <p data-id="element-741">
          Naše usluge nisu usmerene ka pojedincima mlađim od 18 godina. Ne
          prikupljamo svesno lične informacije od dece.
        </p>
      </div>

      <div data-id="element-742">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-743">
          10. Promene politike privatnosti
        </h3>
        <p data-id="element-744">
          Možemo periodično ažurirati ovu politiku privatnosti. Promene će biti
          objavljene na ovoj stranici sa ažuriranim datumom revizije.
        </p>
      </div>

      <div data-id="element-745">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-746">
          11. Kontaktirajte nas
        </h3>
        <p data-id="element-747">
          Za pitanja vezana za privatnost ili da ostvarite svoja prava,
          kontaktirajte nas na: info@dtech.rs
        </p>
      </div>

      <p className="text-sm text-gray-400 mt-8" data-id="element-748">
        Poslednje ažuriranje:{' '}
        {new Date().toLocaleDateString('sr-RS', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>
    </div>;
  return <main className="min-h-screen bg-dark-bg" data-id="element-749">
      {/* Hero */}
      <section className="py-20 bg-dark-surface border-b-2 border-dark-border" data-id="element-750">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-751">
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6" data-id="element-752">
            Pravno i <span className="text-brand-yellow" data-id="element-753">FAQ</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-754">
            Važne informacije o našim uslugama, uslovima i vašim pravima.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-20" data-id="element-755">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-756">
          <Tabs tabs={[{
          id: 'faq',
          label: 'FAQ',
          content: faqContent
        }, {
          id: 'terms',
          label: 'Uslovi korišćenja',
          content: termsContent
        }, {
          id: 'privacy',
          label: 'Politika privatnosti',
          content: privacyContent
        }]} defaultTab="faq" data-id="element-757" />
        </div>
      </section>
    </main>;
}